import { useState, useEffect } from 'react'
import { DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { StoredPaymentMethod } from 'models'
import { CreditCardList } from './CreditCardList'
import { KDialog } from 'components/core/KDialog'
import { KDialogCloseButton } from 'components/ordering/KDialogCloseButton'
import { useTranslation } from 'react-i18next'
import { KButton } from 'components/core/KButton'

export interface CreditCardSelectionDialogProps {
  open: boolean
  onClose: () => void
  onSelectCard: (card: StoredPaymentMethod) => void
  selectedCard?: StoredPaymentMethod
}

export const CreditCardSelectionDialog = ({
  open,
  onClose,
  onSelectCard,
  selectedCard,
}: CreditCardSelectionDialogProps) => {
  const { t } = useTranslation()
  const [currentSelectedCard, setCurrentSelectedCard] = useState<
    StoredPaymentMethod | undefined
  >(selectedCard)

  useEffect(() => {
    setCurrentSelectedCard(selectedCard)
  }, [selectedCard])

  const handleSelectCard = (card: StoredPaymentMethod) => {
    setCurrentSelectedCard(card)
  }

  const handleSaveChanges = () => {
    if (currentSelectedCard) {
      onSelectCard(currentSelectedCard)
      onClose()
    }
  }

  return (
    <KDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle variant="h4" sx={{ paddingX: 0 }}>
        {t('Select payment method')}
      </DialogTitle>

      <DialogContent dividers sx={{ paddingX: 0 }}>
        <CreditCardList
          selectionMode
          selectedCard={currentSelectedCard}
          onSelectCard={handleSelectCard}
          hideActionButtons={true}
        />
      </DialogContent>

      <DialogActions sx={{ paddingX: 0 }}>
        <KButton
          onClick={handleSaveChanges}
          disabled={!currentSelectedCard}
          size="medium"
        >
          {t('Save changes')}
        </KButton>
      </DialogActions>

      <KDialogCloseButton onClick={onClose} />
    </KDialog>
  )
}
